module.exports = {
  WON: 'won',
  LOST: 'lost',
};
